import { ReactNode } from "react";
import { Box, Dialog, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";

// ----------------------------------------------------------------------

interface AppModalProps {
  open: boolean;
  onClose: () => void;
  /** Overline acima do título (ex.: "Cadastro") */
  kicker?: string;
  title?: string;
  subtitle?: string;
  footer?: ReactNode;
  children: ReactNode;
  maxWidth?: number;
}

/** Modal padrão do redesign: kicker + título DM Serif + corpo rolável + footer */
export default function AppModal({ open, onClose, kicker, title, subtitle, footer, children, maxWidth = 720 }: AppModalProps) {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{ backdrop: { sx: { backdropFilter: "blur(4px)" } } }}
      PaperProps={{ sx: { width: "100%", maxWidth, maxHeight: "88vh", display: "flex", flexDirection: "column" } }}
    >
      <Box sx={{ p: "24px 28px 0", display: "flex", alignItems: "flex-start", gap: 2 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {kicker && (
            <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "1.2px", textTransform: "uppercase", color: "primary.main" }}>
              {kicker}
            </Typography>
          )}
          {title && (
            <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: 28, lineHeight: 1.15, color: "text.primary" }}>
              {title}
            </Typography>
          )}
          {subtitle && <Typography sx={{ mt: "3px", fontSize: "13px", color: "text.secondary" }}>{subtitle}</Typography>}
        </Box>
        <Tooltip title="Fechar" placement="top">
          <IconButton onClick={onClose} aria-label="Fechar" sx={{ width: 38, height: 38, borderRadius: "11px", backgroundColor: theme.palette.brand.surface2, color: "secondary.main" }}>
            <CloseRounded sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto", p: "18px 28px 24px" }}>{children}</Box>

      {footer && (
        <Box sx={{ p: "18px 28px", borderTop: `1px solid ${theme.palette.divider}`, display: "flex", justifyContent: "flex-end", gap: 1.5, flexShrink: 0 }}>
          {footer}
        </Box>
      )}
    </Dialog>
  );
}
